export default {
	meta(name, cb, ecb) {
		this.http
			.get('/supplier/meta/' + name, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/supplier', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/supplier', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb) {
		this.http.get('/supplier/' + id, {}).then((r) => cb && cb(r))
	},
	remove(id, cb, ecb) {
		this.http
			.delete('/supplier/' + id, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	}
}
